import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import ImageUploading from "react-images-uploading";
import { fetchHygineTasksLogsDataV2 } from "../../../redux/hygiene-reducers/hygieneSlice";
import SelectDropdown from "../../components-react/SelectDropdown";
import CommonStructured from "../../common-components/CommonStructured";
// import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { convertStraight } from "../../common-data/Converts";

const GymWiseTaskStatusList = ({
  userInfoData,
  rowData,
  prevAllFilters,
  activeGym,
  modName,
  onCloseModal,
}) => {
  const dispatch = useDispatch();
  const { hygineTaskLogsLoadingV2, hygineTaskLogsErrorV2, hygineTaskLogsV2 } =
    useSelector((state) => state.hygiene);

  const [currentTaskIndex, setCurrentTaskIndex] = useState(0);
  const iniFilters = {
    page: currentTaskIndex + 1,
    limit: 1 || 1000,
    task_date: prevAllFilters?.selectedStartDate || "",
    task_id: rowData?.task_id || "",
    stakeholders: prevAllFilters?.selAssignee?.value || "",
    gym_id: activeGym?.gym_id || "",
    status: modName === "total_completed" ? "completed" : "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [taskDatas, setTaskDatas] = useState({});
  const [taskDataPages, setTaskDataPages] = useState([]);

  function getHygieneTasks(filters) {
    dispatch(
      fetchHygineTasksLogsDataV2({
        filters: filters,
        token: userInfoData?.token || "",
      })
    );
  }

  useEffect(() => {
    if (filters.task_id) {
      getHygieneTasks(filters);
    }
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      task_date: prevAllFilters?.selectedStartDate || "",
      stakeholders: prevAllFilters?.selAssignee?.value || "",
      gym_id: activeGym?.gym_id || "",
    }));
  }, [
    prevAllFilters?.selectedStartDate,
    prevAllFilters?.selAssignee,
    activeGym?.gym_id,
  ]);

  useEffect(() => {
    if (
      !hygineTaskLogsLoadingV2 &&
      !hygineTaskLogsErrorV2 &&
      hygineTaskLogsV2?.status &&
      hygineTaskLogsV2?.data
    ) {
      const hygineTask = hygineTaskLogsV2.data;

      setTaskDatas(hygineTask);
      setTaskDataPages(hygineTaskLogsV2?.pagination || []);
    } else {
      setTaskDatas({});
      setTaskDataPages([]);
    }
  }, [hygineTaskLogsLoadingV2, hygineTaskLogsErrorV2, hygineTaskLogsV2]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: currentTaskIndex + 1,
    }));
  }, [currentTaskIndex]);

  // console.log(" <=taskDatas=> ", taskDatas?.task_details);

  return (
    <>
      <CommonStructured
        pageHeading={modName?.replace(/_/g, " ")}
        onCloseModal={onCloseModal}
      />

      {/* {hygineTaskLogsLoadingV2 ? (
        <ReactVortoxSpinner />
      ) : ( */}
        <div
          className="form-container open-form-page-container mod-with-images"
          style={{ marginTop: "30px" }}>
          <form className="formContainer">
            <div className="gym-task-form-inputs">
              <div className="form-top">
                <div className="top-input">
                  <p className="top-input-value">
                    <span className="label">date</span>
                    <span className="support">:</span>
                    <b>
                      {taskDatas?.task_details?.[0]?.task_date
                        ? convertStraight(taskDatas.task_details[0].task_date)
                        : "-"}
                    </b>
                  </p>
                </div>
                <div className="top-input">
                  <p className="top-input-value">
                    <span className="label">task no</span>
                    <span className="support">:</span>
                    <b>{currentTaskIndex + 1}</b>
                  </p>
                </div>
                <div className="top-input">
                  <p className="top-input-value">
                    <span className="label">pending task</span>
                    <span className="support">:</span>
                    <b>
                      <span className={`fulfilled pending`}>
                        {taskDatas?.pendingtasks || 0}
                      </span>
                      /{taskDatas?.totaltasks || 0}
                    </b>
                  </p>
                </div>
              </div>

              {taskDatas?.task_details?.map((task, taskIndex) => {
                const taskImagesLength = task?.images_arr?.length || 0;
                const taskVideosLength = task?.video_arr?.length || 0;

                return (
                  <div key={taskIndex} className={`form-body active`}>
                    <div className={`formInputsGrid threeGridSystem`}>
                      <div className="formInputBox">
                        <label htmlFor="task_name" className="formInputLabel">
                          Task Name
                        </label>

                        <input
                          type="text"
                          className={`formInput`}
                          name="task_name"
                          value={task.task_name || ""}
                          disabled
                        />
                      </div>

                      {task?.task_status && (
                        <div className="formInputBox">
                          <label
                            htmlFor="task_status"
                            className="formInputLabel">
                            Task status <span className="required">*</span>
                          </label>

                          <div className={`commonWrapper`}>
                            <SelectDropdown
                              options={[]}
                              selectedOption={{
                                label: task?.task_status,
                                value: task?.task_status_id,
                                info: task,
                              }}
                              setSelectedOption={{
                                label: task?.task_status,
                                value: task?.task_status_id,
                                info: task,
                              }}
                              name="task status"
                              isDisable={true}
                            />
                          </div>
                        </div>
                      )}

                      {task?.add_gym_req && task.description && (
                        <div className="formInputBox span2">
                          <label
                            htmlFor="description"
                            className="formInputLabel">
                            Task description <span className="required">*</span>
                          </label>

                          <textarea
                            name="description"
                            className={`formInput`}
                            style={{ minHeight: "150px" }}
                            value={task.description}
                            disabled></textarea>
                        </div>
                      )}
                    </div>

                    <div className={`formInputsGrid threeGridSystem mt30`}>
                      {taskImagesLength !== 0 && (
                        <div className="formInputBox">
                          <label className="formInputLabel">
                            Upload Image <span className="required">*</span>
                          </label>
                          <div
                            className={`upload-container ${
                              taskImagesLength <= 1
                                ? "grid-1"
                                : taskImagesLength <= 4
                                ? "grid-2"
                                : taskImagesLength <= 8
                                ? "grid-4"
                                : ""
                            }`}>
                            {task.images_arr.map((imageList, imgIndex) => {
                              return (
                                <div
                                  key={`image-${taskIndex}-${imgIndex}`}
                                  className="upload-box">
                                  <ImageUploading
                                    multiple
                                    value={imageList}
                                    maxNumber={1}
                                    dataURLKey="data_url"
                                    acceptType={["image/*"]}>
                                    {({ imageList }) => (
                                      <div className="upload__image-wrapper">
                                        <div className="image-item">
                                          <img
                                            src={imageList}
                                            alt=""
                                            width="100"
                                          />
                                        </div>
                                      </div>
                                    )}
                                  </ImageUploading>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {taskVideosLength !== 0 && (
                        <div className="formInputBox">
                          <label className="formInputLabel">
                            Upload videos <span className="required">*</span>
                          </label>
                          <div
                            className={`upload-container ${
                              taskVideosLength <= 1
                                ? "grid-1"
                                : taskVideosLength <= 4
                                ? "grid-2"
                                : taskVideosLength <= 8
                                ? "grid-4"
                                : ""
                            }`}>
                            {task.video_arr.map((_, videoIndex) => (
                              <div
                                key={`video-${taskIndex}-${videoIndex}`}
                                className="upload-box">
                                <ImageUploading
                                  multiple
                                  value={task.video_arr[videoIndex] || []}
                                  maxNumber={1}
                                  dataURLKey="data_url"
                                  acceptType={["video/*"]}>
                                  {({ imageList }) => (
                                    <div className="upload__image-wrapper">
                                      <div className="image-item">
                                        <video width="100" controls>
                                          <source
                                            src={imageList}
                                            type="video/mp4"
                                          />
                                        </video>
                                      </div>
                                    </div>
                                  )}
                                </ImageUploading>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}

              <div className="navigation-buttons">
                <Button
                  type="button"
                  onClick={() => {
                    setCurrentTaskIndex((prev) => Math.max(prev - 1, 0));
                  }}
                  disabled={currentTaskIndex === 0}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-left"
                    viewBox="0 0 16 16">
                    <path
                      fillRule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                    />
                  </svg>
                </Button>
                <Button
                  type="button"
                  onClick={() => {
                    const totalPages = taskDataPages?.[0]?.pages || 1;
                    if (currentTaskIndex < totalPages - 1) {
                      setCurrentTaskIndex((prev) => prev + 1);
                    }
                  }}
                  disabled={
                    currentTaskIndex === (taskDataPages?.[0]?.pages || 1) - 1
                  }>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-right"
                    viewBox="0 0 16 16">
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>
                </Button>
              </div>
              {/* <div className="navigation-buttons">
                <Button
                  type="button"
                  onClick={() =>
                    setCurrentTaskIndex((prev) => Math.max(prev - 1, 0))
                  }
                  disabled={currentTaskIndex === 0}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-left"
                    viewBox="0 0 16 16">
                    <path
                      fillRule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                    />
                  </svg>
                </Button>
                <Button
                  type="button"
                  onClick={() =>
                    setCurrentTaskIndex((prev) =>
                      Math.min(prev + 1, taskDatas?.task_details?.length - 1)
                    )
                  }
                  disabled={
                    currentTaskIndex === taskDatas?.task_details?.length - 1
                  }>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-arrow-right"
                    viewBox="0 0 16 16">
                    <path
                      fillRule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>
                </Button>
              </div> */}
            </div>
          </form>
        </div>
      {/* )} */}
    </>
  );
};

export default GymWiseTaskStatusList;
